@if (_document) {
  <div>
    <document-lines-editor
      #lineGrid
      [title]="'Doc::SupplierReturnNote:ProductsAndServices' | abpLocalization"
      [columnDefs]="columnDefs"
      [rows]="_document?.lines"
      [getContextMenuItems]="getContextMenuItems"
      [onCellFocused]="onCellFocused"
      [onRowSelected]="onRowSelected"
      [onCellValueChanged]="onCellValueChanged"
      [treeData]="true"
      [getDataPath]="getDataPath"
      [textLineRole]="textLineRole"
      [chapterLineRole]="chapterLineRole"
      [readonly]="_readonly"
      [canAddLines]="document.returnStatus == SupplierReturnStatus.Open"
      [addActionBtns]="addActionBtns"
      [deleteActionEnabled]="
        document.returnStatus === SupplierReturnStatus.Open && deleteActionEnabled
      "
      [selectedLines]="selectedLines()"
      (deleteLines)="deleteLines()"
      [canExportLines]="false"
      [thirdPartyDoc]="_document"
      [isBusyAdding]="isBusyAdding"
      (onModelUpdated)="onModelUpdated($event)"
    ></document-lines-editor>
  </div>
}
